export const STATUS_CODES = {
  OK: 200,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  PreconditionRequired: 428,
  InternalServerError: 500,
} as const;
